import { useState, useRef, useEffect } from "react";
import video1 from "../assets/videos/video1.mp4";
import video2 from "../assets/videos/video2.mp4";
import video3 from "../assets/videos/video3.mp4";

const videos = [video1, video2, video3];

export default function Hero() {
  const videoRef = useRef(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleEnded = () => {
      setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
    };

    if (videoElement) {
      videoElement.addEventListener("ended", handleEnded);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleEnded);
      }
    };
  }, []);

  useEffect(() => {
    const playVideo = async () => {
      try {
        if (videoRef.current) {
          videoRef.current.load();
          await videoRef.current.play();
        }
      } catch (error) {
        console.log("Video play interrupted:", error);
      }
    };
    playVideo();
  }, [currentVideoIndex]);

  return (
    <>
      <section className="relative h-screen overflow-hidden text-center pt-16">
        {/* Video Background */}
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source src={videos[currentVideoIndex]} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Optional: Overlay */}
        <div className="absolute top-0 left-0 w-full h-full bg-green-50/30 z-10"></div>

        {/* Content moved to top-right corner */}
        <div className="relative z-20 flex items-start justify-end h-full w-full p-8">
          <div className="text-right max-w-xs mt-8">
            <h2 className="text-xl md:text-4xl font-bold mb-2 text-white drop-shadow-lg whitespace-nowrap">
              Future of E-Mobility
            </h2>

            <p className="text-sm md:text-lg text-gray-100 drop-shadow">
              Affordable. Eco-Friendly. Reliable.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
